import produce from 'immer';

import { IUserState } from './IUserState';
import { UserActions, UserActionTypes } from './UserActions';
import { UserSecurityRoles } from '../../shared/userSecurityRoles';

const initialUserState: IUserState = {
  userDetails: {
    id: 0,
    firstname: '',
    lastname: '',
    email: '',
    defaultDivisionId: undefined,
    securityRoleCode: UserSecurityRoles.Undefined
  },
};

const UserReducer: (
  state: IUserState | undefined,
  action: UserActions,
) => IUserState = (
  state: IUserState = initialUserState,
  action: UserActions,
): IUserState => {
  let newState: IUserState = { ...state };

  switch (action.type) {
    case UserActionTypes.SET_USER_DETAILS:
      newState = produce(state, (draftState: IUserState) => {
        draftState.userDetails = action.userDetails;
      });
      break;
    default:
      return state;
  }

  return newState;
};

export default UserReducer;
